export const REPORTS_ROUTE_NAMES = {
    REPORTS: "ReportsPage",
    REPORTS_ATTENDANCE: "ReportsAttendance",
    REPORTS_EFFICIENCY: "ReportsEfficiency",
    REPORTS_INCOME: "ReportsIncome",
    REPORTS_PRODUCT_INCOME: "ReportsProductIncome",
    REPORTS_PRODUCT_LEFTOVER: "ReportsProductLeftover",
    REPORTS_REVISE: "ReportsRevise",
    REPORTS_PAYMENTS: "ReportsPayments",
    REPORTS_PROFIT: "ReportsProfit",
};
